import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';

@Component({
  selector: 'mojo-table-paginator',
  templateUrl: './table-paginator.component.html'
})
export class TablePaginatorComponent implements OnInit {

  @Input() rowCountOverride: number;
  @Input() showPaginator = true;
  @Input() table: Table;
  @ViewChild('paginator', { static: true }) paginator: Paginator;

  constructor() { }

  ngOnInit() {
    this.table.paginator = this.showPaginator;
  }

  goToFirstPage() {
    if (this.paginator && this.showPaginator)
      this.paginator.changePage(0);
  }

  paginate(event): void {
    this.table.first = event.first;
  }

  getTotalRecords(): string {
    const count = this.rowCountOverride ||
      (this.table ? this.table.totalRecords : null) ||
      (this.table && this.table.value ? this.table.value.length : null) ||
      null;

    const plural : boolean = count > 1;
    return count
      ? `${count} record${plural ? 's' : ''} found`
      : '';
  }

}
